"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeElementCreator = exports.createElement = void 0;

var _ramda = require("ramda");

var _attribute = require("./attribute.apply");

var _element = require("./element.apply");

var _namespace = require("./namespace.constants");

var _nodeNameHelpers = require("./nodeNameHelpers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// ElementCreationOptions is { children: [DOMNode], attributes: { String: String }, text: String }
var createElement = function createElement(dom, namespaceURI, qualifiedName) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var el = namespaceURI ? dom.createElementNS(namespaceURI, qualifiedName) : dom.createElement(qualifiedName);
  var _options$children = options.children,
      children = _options$children === void 0 ? [] : _options$children,
      _options$attributes = options.attributes,
      attributes = _options$attributes === void 0 ? {} : _options$attributes,
      _options$nsAttributes = options.nsAttributes,
      nsAttributes = _options$nsAttributes === void 0 ? {} : _options$nsAttributes,
      _options$namespaces = options.namespaces,
      namespaces = _options$namespaces === void 0 ? {} : _options$namespaces,
      text = options.text;

  if (text) {
    el.textContent = text;
  }

  (0, _element.applyChildren)(el, children);
  (0, _attribute.applyAttributes)(el, attributes);

  if (!((0, _ramda.isEmpty)(nsAttributes) && (0, _ramda.isEmpty)(namespaces))) {
    (0, _attribute.applyAttributesNsGroups)(el, (0, _ramda.mergeDeepRight)(nsAttributes, _defineProperty({}, _namespace.nsXmlns, (0, _attribute.makeNamespaceDeclarations)(namespaces))));
  }

  return el;
}; // (String, String) -> (DOMDocument, String, ElementCreationOptions) -> DOMElement


exports.createElement = createElement;

var makeElementCreator = function makeElementCreator(namespaceURI) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return function (dom, localName) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return createElement(dom, namespaceURI, (0, _nodeNameHelpers.makeQName)(localName, prefix), options);
  };
};

exports.makeElementCreator = makeElementCreator;